import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { PRODUCT_URL } from '../environments/environment';
import { ResponseProductFilters } from '../types/ResponseProductFilters';
import { PagedResponse } from '../types/PagedResponse';
import { Product } from '../types/Product';
import { ResponseOriginCode } from '../types/dai-server/products/ResponseOriginCode';
import { PriceCode } from '../types/PriceCode';

export interface DynamicFilters {
    [key: string]: string[];
}

@Injectable({
    providedIn: 'root'
})
export class ProductService {

    private apiUrl = PRODUCT_URL;

    constructor(private http: HttpClient) { }

    public getNewProject(type: string): Observable<Product> {
        return this.http.get<Product>(`${this.apiUrl}/new/${type}`);
    }

    createProduct(product: Product): Observable<Product> {
        return this.http.post<Product>(`${this.apiUrl}`, product);
    }

    public searchProduct(type: string, filter: DynamicFilters, omniSearch: string, orderBy: string, page: number, pageSize: number): Observable<PagedResponse<Product>> {
        const params: Record<string, string | string[]> = {};

        for (const key in filter) {
            params[key] = filter[key];
        }

        params['omniSearch'] = omniSearch;
        params['orderBy'] = orderBy;
        params['page'] = page.toString();
        params['pageSize'] = pageSize.toString();

        return this.http.get<PagedResponse<Product>>(`${this.apiUrl}/search/${type}`, {
            params
        });
    }

    public productFilters(type: string, filters?: DynamicFilters): Observable<ResponseProductFilters> {
        return this.http.get<ResponseProductFilters>(`${this.apiUrl}/search/${type}/filters`, { params: filters });
    }

    getProduct(id: string): Observable<Product> {
        return this.http.get<Product>(`${this.apiUrl}/${id}`);
    }

    updateProduct(id: string, product: Product): Observable<Product> {
        return this.http.put<Product>(`${this.apiUrl}/${id}`, product);
    }

    public getOriginCodes(): Observable<ResponseOriginCode[]> {
        return this.http.get<ResponseOriginCode[]>(`${this.apiUrl}/origin-codes`);
    }

    public uploadProductImage(file: File, productType: string, productSKU: string): Observable<HttpEvent<any>> {
        const formData = new FormData();
        formData.append('Image', file);
        formData.append('ProductType', productType);
        formData.append('ProductSKU', productSKU);

        const req = new HttpRequest('POST', `${this.apiUrl}/uploadimage`, formData, {
            reportProgress: true,
        });

        return this.http.request(req);
    }

    productPrice(id: string): Observable<PriceCode[]> {
        return this.http.get<PriceCode[]>(`${this.apiUrl}/price-codes/${id}`);
    }

    saveProductPrice(id: string, codes: PriceCode[]): Observable<PriceCode[]> {
        return this.http.post<PriceCode[]>(`${this.apiUrl}/price-codes/${id}`, codes);
    }

}